import { createContext, useContext, useEffect, useState } from 'react'
import { post, get, obtainToken, bindUserSession } from '../api/auth'
import { useLocalStorage } from '../useLocalStorage'
import { message } from 'antd'
import { getApiHost } from '../api/consts'
import { useCookies } from 'react-cookie'

const AuthContext = createContext({})

export const useAuth = () => {
  return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
  const [apiHost] = useState(getApiHost())
  const [token, setToken] = useState(null)
  const [user, setUser] = useLocalStorage('user', '')
  const [userId, setUserId] = useLocalStorage('userId', '')
  const [cookies] = useCookies(['partner_id', 'ambassador'])

  useEffect(() => {
    const authenticate = async () => {
      const currentToken = await obtainToken()
      if (currentToken) {
        setToken(currentToken.auth_token)
      }
    }
    authenticate()
  }, [])

  useEffect(() => {
    if (token) {
      getBusinessPartner(token)
    }
  }, [token])

  const getBusinessPartner = async (myToken) => {
    try {
      const result = await get(`${apiHost}/resource/v3/me`, myToken)
      if (result['business_partner']) {
        setUser(result['business_partner']['screenname'])
        setUserId(result['business_partner']['_id'])
      }
    } catch (error) {
      message.error(`Authentication failed:\n${error}`)
    }
  }

  const handleAuthRequest = async (url, values, onSuccess, onError) => {
    const result = await post(url, values)
    if (result['error']) {
      onError(result['error'])
    } else {
      if (result.auth_token) {
        await bindUserSession(result.auth_token)
        setToken(result.auth_token)
      }
      onSuccess()
    }
    return true
  }

  const handleLogin = (values, onSuccess, onError) => {
    return handleAuthRequest(`${apiHost}/auth/auth`, values, onSuccess, onError)
  }

  const handleRegister = (values, onSuccess, onError) => {
    const requestPayload = {
      ...values,
    }
    if (cookies.partner_id !== undefined) {
      requestPayload.partner_id = cookies.partner_id
    }
    if (cookies.ambassador !== undefined) {
      requestPayload.ambassador = cookies.ambassador
    }
    return handleAuthRequest(
      `${apiHost}/auth/register`,
      requestPayload,
      onSuccess,
      onError
    )
  }
  const handleRequestNewPassword = (values, onSuccess, onError) => {
    return handleAuthRequest(
      `${apiHost}/auth/recover`,
      values,
      onSuccess,
      onError
    )
  }

  const getUserNames = () => {
    const parts = user.split(' ')
    let firstName = ''
    if (parts[0].endsWith('.')) {
      // like Dr.
      firstName = parts[1]
    } else {
      firstName = parts[0]
    }
    return { firstName, lastName: parts[parts.length - 1] }
  }

  const value = {
    token,
    apiHost,
    user,
    getUserNames: getUserNames,
    userId,
    onLogin: handleLogin,
    onRegister: handleRegister,
    onRequestNewPassword: handleRequestNewPassword,
  }
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
